import React, { Component } from 'react';
import { Row, Col, Card, CardBody, FormGroup, Button, Label, Spinner, Modal, ModalHeader, ModalBody, TabContent, Nav, TabPane, NavLink, NavItem } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import classnames from "classnames";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import Select from "react-select";
import Moment from 'moment';
import SweetAlert from "react-bootstrap-sweetalert";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import { BaseUrl } from "../../helpers/Baseurl";
import { toTitleCase, getDifferenceInDays } from '../../helpers/methods';
import { get } from '../../helpers/api_helper';

const HotelPricingType = [
    { 
        label: "Price",
        options: [
            { label: "EP", value: "ep" },
            { label: "CP", value: "cp" },
            { label: "MAP", value: "map" },
        ]
    }
];

const HotelRatingType = [
    { 
        label: "Rating",
        options: [
            { label: "2", value: 2 },
            { label: "3", value: 3 },
            { label: "4", value: 4 },
            { label: "5", value: 5 },
        ]
    }
];

class HotelsDetail extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            activeTabJustify: "5",
            hotel_success_confirm: false,
            hotel_alert_confirm: false,
            dynamic_title: "",
            dynamic_description: "",
            addHotelloading: false,
            editHotelloading: false,
            addRoomsloading: false,
            itinerary: this.props.data || {}, // Ensure itinerary is initialized
            hotel_id: "",
            itineraryHotels: [],
            hotelLocationsGroup: [],
            hotelsGroup: [],
            HotelTypeGroup: [],
            HotelRoomTypeGroup: [],
            hotelPricing: [],
            selectedHotelLocation: { label: "Select location", value: null },
            selectedHotelRating: { label: "Select Hotel Rating", value: null },
            selectedHotel: { label: "Select Hotel", value: null },
            selectedHotelMealType: { label: "Select Meal Plan", value: null },
            selectedRoomType: { label: "Select Category", value: null },
            selectedFromDate: null,
            selectedToDate: null,
            numberOfNights: 1,
            selectedHotelData: null,
            price: 0,
            count: 1,
            selectedRooms: [],
            selected_hotel: {}
        };

        toastr.options = {
            positionClass: "toast-top-right",
            closeButton: "false",
            progressBar: "true",
            showEasing: "swing",
            hideEasing: "linear",
            showMethod: "fadeIn",
            hideMethod: "fadeOut",
            showDuration: 300,
            hideDuration: 1000,
            timeOut: 5000,
            extendedTimeOut: 1000
        };
        
        this.handleSelectedHotelRating = this.handleSelectedHotelRating.bind(this);
        this.clearStateData = this.clearStateData.bind(this); 
        this.tog_addHotel = this.tog_addHotel.bind(this); 
        this.tog_addRooms = this.tog_addRooms.bind(this); 
        this.handleHotelDelete = this.handleHotelDelete.bind(this); 
        this.handleSaveHotel = this.handleSaveHotel.bind(this); 
        this.handleEditHotelSubmit = this.handleEditHotelSubmit.bind(this);
        this.handleUpdateHotelData = this.handleUpdateHotelData.bind(this);
        this.handleRoomCountSave = this.handleRoomCountSave.bind(this);
        this.handleAddRoomSubmit = this.handleAddRoomSubmit.bind(this);
        this.handleHotelRoomDelete = this.handleHotelRoomDelete.bind(this);
        this.addInput = this.addInput.bind(this);
        this.removeInput = this.removeInput.bind(this);
        this.getHotelPrice = this.getHotelPrice.bind(this);
        this.toggleCustomJustified = this.toggleCustomJustified.bind(this);
        this.handleNumberOfNightsChange = this.handleNumberOfNightsChange.bind(this);
        this.handleFromDateChange = this.handleFromDateChange.bind(this);
        this.handleToDateChange = this.handleToDateChange.bind(this);
    }  

    clearStateData() {
        this.setState({
            addHotelloading: false,
            editHotelloading: false,
            hotel_id: "",
            hotelsGroup: [],
            HotelRoomTypeGroup: [],
            hotelPricing: [],
            selectedHotelLocation: { label: "Select location", value: null },
            selectedHotel: { label: "Select Hotel", value: null },
            selectedHotelData: null,
            selectedHotelMealType: { label: "Select Meal Type", value: null },
            selectedRoomType: { label: "Select Category", value: null },
            selectedHotelRating: { label: "Select Hotel Rating", value: null },
            selectedFromDate: null,
            selectedToDate: null,
            numberOfNights: 1,
            model_editHotel: false,
            model_addHotel: false,
            count: 1,
            selectedRooms: []
        });
    }

    addInput() {
        const { count, selectedRooms } = this.state;
        this.setState({ count: count + 1, selectedRooms: [...selectedRooms] });
    }
    
    removeInput() {
        const { count, selectedRooms } = this.state;
        const newSelectedRooms = [...selectedRooms];
        newSelectedRooms.pop();
        this.setState({ count: count - 1, selectedRooms: newSelectedRooms });
    }

    tog_addHotel() {
        const { itineraryHotels, itinerary } = this.state;
        let selectedFromDate = null;
        let selectedToDate = null;
        let numberOfNights = 1;

        // Safely determine default check-in date
        if (itineraryHotels.length > 0) {
            const lastHotel = itineraryHotels.sort((a, b) => new Date(b.to_date) - new Date(a.to_date))[0];
            if (lastHotel.to_date) {
                selectedFromDate = new Date(lastHotel.to_date);
            }
        }
        if (!selectedFromDate && itinerary.start_date) {
            selectedFromDate = new Date(itinerary.start_date);
        }

        // Set default checkout date based on number of nights
        if (selectedFromDate) {
            selectedToDate = new Date(selectedFromDate);
            selectedToDate.setDate(selectedFromDate.getDate() + numberOfNights);
        }

        this.setState({
            model_addHotel: !this.state.model_addHotel,
            selectedFromDate,
            selectedToDate,
            numberOfNights
        });
        this.removeBodyCss();
    }

    tog_editHotel() {
        this.setState(prevState => ({
            model_editHotel: !prevState.model_editHotel
        }));
        this.removeBodyCss();
    }

    tog_addRooms() {
        this.setState(prevState => ({
            model_addRooms: !prevState.model_addRooms
        }));
        this.removeBodyCss();
    }

    removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    toggleCustomJustified(tab) {
        if (this.state.activeTabJustify !== tab) {
            this.setState({
                activeTabJustify: tab
            });
        }
    }

    componentDidCatch(error) {
        console.error("Error in HotelsDetail:", error);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.data !== this.props.data) {
            const itinerary = this.props.data || {};
            this.setState({ itinerary });
        }
        if (prevProps.data?.destinations !== this.props.data?.destinations) {
            this.loadItineraryDestinarion();
        }
    }

    async componentDidMount() {
        await this.loadItineraryHotels();
        this.loadItineraryDestinarion();
    }

    loadFunc = async () => {
        await this.loadItineraryHotels();
        this.loadItineraryDestinarion();
    };

    loadItineraryDestinarion() {
        const destinations = this.props.data?.destinations || [];
        const options = destinations.map(destination => ({
            label: destination.name,
            value: destination.id
        }));
        const hotelLocationsGroup = [{
            label: "Destinations",
            options
        }];
        this.setState({ hotelLocationsGroup });
    }
    
    async loadItineraryHotels() {
        const { itinerary } = this.state;
        if (!itinerary.id) return;

        this.setState({ itineraryHotels: [] });
        this.clearStateData();
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.props.access}` },
        };
        try {
            const response = await get(`${BaseUrl}/api/itineraries/itinerary-hotels/?itinerary__id=${itinerary.id}`, requestOptions);
            this.props.handleHotelTotal(this.handleHotelsTotal(response));
            this.setState({ itineraryHotels: response });
            this.clearStateData();
        } catch (error) {
            console.error("Error loading itinerary hotels:", error);
            toastr.error("Failed to load hotels", "");
        }
    }

    handleHotelsTotal(hotels) {
        let priceByDate = {};
        for (let i = 0; i < hotels.length; i++) {
            const date = hotels[i].from_date;
            const price = parseInt(hotels[i].margin_price) || 0;
            if (!priceByDate[date] || price > priceByDate[date]) {
                priceByDate[date] = price;
            }
        }
        let total = 0;
        for (let date in priceByDate) {
            total += priceByDate[date];
        }
        return total;
    }
    
    async loadHotelByPlacesData(rating, destination__id) {
        if (rating && destination__id) {
            const requestOptions = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.props.access}` },
            };
            try {
                const response = await fetch(`${BaseUrl}/api/hotels/hotels/?size=100&rating=${rating}&destination__id=${destination__id}`, requestOptions);
                const data = await response.json();
                const options = data.results.map(hotel => ({
                    label: hotel.name,
                    value: hotel.id
                }));
                const hotelsGroup = [{
                    label: "Hotels",
                    options
                }];
                this.setState({ hotelsGroup });
            } catch (error) {
                console.error("Error loading hotels:", error);
                toastr.error("Failed to load hotels", "");
            }
        }
    }
    
    async loadHotelData(id) {
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.props.access}` },
        };
        try {
            const response = await fetch(`${BaseUrl}/api/hotels/hotels/${id}/`, requestOptions);
            const data = await response.json();
            const options = data.pricing.map(pricing => ({
                label: pricing.room_type.name,
                value: pricing.id
            }));
            const HotelRoomTypeGroup = [{
                label: "Room",
                options
            }];
            const selectedHotelData = data.hotel;
            this.setState({ HotelRoomTypeGroup, hotelPricing: data.pricing, hotelSeasons: data.seasons, selectedHotelData });
        } catch (error) {
            console.error("Error loading hotel data:", error);
            toastr.error("Failed to load hotel data", "");
        }
    }

    async loadselectedHotelData(id) {
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.props.access}` },
        };
        try {
            const response = await fetch(`${BaseUrl}/api/itineraries/itinerary-hotels/${id}/`, requestOptions);
            const data = await response.json();
            this.setState({ selected_hotel: data });
        } catch (error) {
            console.error("Error loading selected hotel data:", error);
            toastr.error("Failed to load hotel data", "");
        }
    }

    is_Season() {
        const { hotelSeasons, selectedFromDate } = this.state;
        if (!selectedFromDate || !hotelSeasons) return false;

        for (let k = 0; k < hotelSeasons.length; k++) {
            let seasonStartDate = new Date(`${hotelSeasons[k].start_month}-${hotelSeasons[k].start_date}-${selectedFromDate.getFullYear()}`);
            let seasonEndDate = new Date();
            if (hotelSeasons[k].start_month > hotelSeasons[k].end_month) {
                seasonEndDate = new Date(`${hotelSeasons[k].end_month}-${hotelSeasons[k].end_date}-${selectedFromDate.getFullYear() + 1}`);
            } else {
                seasonEndDate = new Date(`${hotelSeasons[k].end_month}-${hotelSeasons[k].end_date}-${selectedFromDate.getFullYear()}`);
            }
            if (selectedFromDate >= seasonStartDate && selectedFromDate <= seasonEndDate) {
                return true;
            }
        }
        return false;
    }

    handleSelectedHotelLocation = selectedHotelLocation => {
        const { selectedHotelRating } = this.state;
        this.loadHotelByPlacesData(selectedHotelRating.value, selectedHotelLocation.value);
        this.setState({
            selectedHotelLocation,
            selectedHotel: { label: "Select Hotel", value: null },
            selectedHotelData: null
        });
    }

    handleSelectedHotelRating = selectedHotelRating => {
        const { selectedHotelLocation } = this.state;
        this.loadHotelByPlacesData(selectedHotelRating.value, selectedHotelLocation.value);
        this.setState({
            selectedHotelRating,
            selectedHotel: { label: "Select Hotel", value: null },
            selectedHotelData: null
        });
    }

    handleSelectedHotel = selectedHotel => {
        this.loadHotelData(selectedHotel.value);
        this.setState({
            selectedHotel,
            price: 0,
            count: 1,
            selectedRoomType: { label: "Select Category", value: null },
            selectedRooms: [],
            selectedHotelMealType: { label: "Select Meal Plan", value: null }
        });
    }

    handleSelectedRoomType = selectedRoomType => {
        const { selected_hotel } = this.state;
        const rooms = selected_hotel.room_price || [];
        const selected = rooms.map(room => room.room.id);
        if (selected.includes(selectedRoomType.value)) {
            toastr.error(`${selectedRoomType.label} already selected`, "");
            this.setState({ selectedRoomType: { label: "Select Category", value: null } });
        } else {
            this.setState({ selectedRoomType });
        }
    }

    handleSelectedRooms = (selectedroom, index) => {
        const { selectedRooms } = this.state;
        if (selectedRooms.includes(selectedroom.value)) {
            toastr.error(`${selectedroom.label} already selected`, "");
        } else {
            const newSelectedRooms = [...selectedRooms];
            newSelectedRooms.push(selectedroom.value);
            this.setState({ selectedRooms: newSelectedRooms });
        }
    };

    handleHotelDelete = async (id) => {
        const requestOptions = {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${this.props.access}` },
        };
        try {
            const response = await fetch(`${BaseUrl}/api/itineraries/itinerary-hotels/${id}/`, requestOptions);
            if (response.status >= 400) {
                throw new Error("Failed to delete hotel");
            }
            await this.loadItineraryHotels();
            this.setState({
                hotel_id: "",
                hotel_success_confirm: true,
                hotel_alert_confirm: false,
                dynamic_title: "Deleted!",
                dynamic_description: "Hotel has been deleted."
            });
        } catch (error) {
            console.error("Error deleting hotel:", error);
            toastr.error("Failed to delete hotel", "");
        }
    }

    handleHotelEdit = (id) => {
        const { itineraryHotels } = this.state;
        const selected_hotel = itineraryHotels.find(hotel => hotel.id === id);
        if (selected_hotel) {
            const selectedHotelLocation = { label: selected_hotel.hotel.place.name, value: selected_hotel.hotel.place.id };
            const selectedHotelRating = { label: selected_hotel.hotel.rating, value: selected_hotel.hotel.rating };
            const selectedHotel = { label: selected_hotel.hotel.name, value: selected_hotel.hotel.id };
            const selectedHotelMealType = { label: toTitleCase(selected_hotel.price_type), value: selected_hotel.price_type };
            const selectedFromDate = new Date(selected_hotel.from_date);
            const selectedToDate = new Date(selected_hotel.to_date);
            const selectedRooms = selected_hotel.room_price.map(room => room.room.id);
            const count = selectedRooms.length;
            const numberOfNights = Math.ceil((selectedToDate - selectedFromDate) / (1000 * 60 * 60 * 24)) || 1;

            this.setState({
                selected_hotel,
                selectedHotelLocation,
                selectedHotel,
                selectedHotelMealType,
                selectedFromDate,
                selectedToDate,
                selectedHotelRating,
                selectedRooms,
                count,
                numberOfNights
            });
            this.tog_editHotel();
            this.loadHotelData(selectedHotel.value);
            this.loadHotelByPlacesData(selectedHotelRating.value, selectedHotelLocation.value);
        }
    };

    handleHotelRoomDelete = async (row) => {
        const { selected_hotel } = this.state;
        let price = 0;
        if (selected_hotel.price_type === "map") {
            price = row.room.map_price;
        } else if (selected_hotel.price_type === "cp") {
            price = row.room.cp_price;
        } else {
            price = row.room.ep_price;
        }
        const total_price = parseInt(selected_hotel.margin_price) - (parseInt(price) * parseInt(row.count));
        const data = { "margin_price": total_price };
        const requestOptions = {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${this.props.access}` },
        };
        try {
            const response = await fetch(`${BaseUrl}/api/itineraries/itinerary-hotel-rooms/${row.id}/`, requestOptions);
            if (response.status >= 400) {
                throw new Error("Failed to delete room");
            }
            await this.handleUpdateHotelData(selected_hotel.id, data);
            this.setState({
                hotel_id: "",
                edithotel_success_confirm: true,
                edithotel_alert_confirm: false,
                dynamic_title: "Deleted!",
                dynamic_description: "Room has been deleted."
            });
        } catch (error) {
            console.error("Error deleting room:", error);
            this.setState({
                hotel_id: "",
                edithotel_success_confirm: false,
                edithotel_alert_confirm: false,
                dynamic_title: "",
                dynamic_description: ""
            });
            toastr.error("Something Went Wrong", "");
        }
    }

    handleRoomCountSave = async (old_val, row) => {
        const { selected_hotel } = this.state;
        const newValue = parseInt(row.count);
        const oldValue = parseInt(old_val);
        const data = {
            itinerary: row.itinerary,
            room: row.room.id,
            count: newValue
        };

        let hotel_price = false;
        let price = 0;
        if (newValue !== oldValue && newValue > 0) {
            hotel_price = {};
            if (selected_hotel.price_type === "map") {
                price = row.room.map_price;
            } else if (selected_hotel.price_type === "cp") {
                price = row.room.cp_price;
            } else {
                price = row.room.ep_price;
            }

            if (oldValue < newValue) {
                const diff = newValue - oldValue;
                const total_price = parseInt(selected_hotel.margin_price) + (parseInt(price) * parseInt(diff));
                hotel_price["margin_price"] = total_price;
            } else {
                const diff = oldValue - newValue;
                const total_price = parseInt(selected_hotel.margin_price) - (parseInt(price) * parseInt(diff));
                hotel_price["margin_price"] = total_price;
            }
        }
        
        const requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.props.access}` },
            body: JSON.stringify(data)
        };
        try {
            const response = await fetch(`${BaseUrl}/api/itineraries/itinerary-hotel-rooms/${row.id}/`, requestOptions);
            if (response.status >= 400) {
                const errorData = await response.json();
                console.error("Error updating room count:", errorData);
                toastr.error("Something Went Wrong", "");
            } else if (hotel_price) {
                await this.handleUpdateHotelData(selected_hotel.id, hotel_price);
            }
        } catch (error) {
            console.error("Error updating room count:", error);
            toastr.error("Something Went Wrong", "");
        }
    }

    handleAddRoomSubmit = async (e, values) => {
        const { selectedRoomType, selected_hotel, hotelPricing, itinerary } = this.state;
        if (selectedRoomType.value === null) {
            toastr.error(`Select Category`, "");
            return;
        }

        this.setState({ addRoomsloading: true });
        const selected_price = hotelPricing.find(price => price.id === selectedRoomType.value);
        const is_season = this.is_Season();
        let total_price = parseInt(selected_hotel.margin_price) || 0;
        if (selected_price) {
            total_price += selected_hotel.price_type === "map"
                ? parseInt((is_season ? selected_price.on_season_map_price : selected_price.map_price) * values.rooms_count)
                : selected_hotel.price_type === "cp"
                ? parseInt((is_season ? selected_price.on_season_cp_price : selected_price.cp_price) * values.rooms_count)
                : parseInt((is_season ? selected_price.on_season_ep_price : selected_price.ep_price) * values.rooms_count);
        }

        const rooms_data = {
            itinerary: itinerary.id,
            room: [selectedRoomType.value],
            count: [values.rooms_count]
        };

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.props.access}` },
            body: JSON.stringify(rooms_data)
        };
        try {
            const response = await fetch(`${BaseUrl}/api/itineraries/itinerary-hotel-rooms/`, requestOptions);
            if (response.status >= 400) {
                const errorData = await response.json();
                console.error("Error adding room:", errorData);
                toastr.error("Something Went Wrong", "");
                this.setState({ addRoomsloading: false });
            } else {
                const data = await response.json();
                const newdata = {
                    room_price: [...selected_hotel.room_price.map(r => r.id), ...data],
                    margin_price: total_price
                };
                this.setState({
                    addRoomsloading: false,
                    model_addRooms: false,
                    selectedRooms: [...this.state.selectedRooms, selectedRoomType.value],
                    count: this.state.count + 1
                });
                await this.handleUpdateHotelData(selected_hotel.id, newdata);
            }
        } catch (error) {
            console.error("Error adding room:", error);
            toastr.error("Something Went Wrong", "");
            this.setState({ addRoomsloading: false });
        }
    }

    handleNumberOfNightsChange = (e) => {
        const numberOfNights = parseInt(e.target.value) || 1;
        const { selectedFromDate, itinerary } = this.state;
        if (numberOfNights < 1) {
            toastr.error("Number of nights must be at least 1", "");
            return;
        }

        if (selectedFromDate && itinerary.end_date) {
            const selectedToDate = new Date(selectedFromDate);
            selectedToDate.setDate(selectedFromDate.getDate() + numberOfNights);
            const maxDate = new Date(itinerary.end_date);
            if (selectedToDate <= maxDate) {
                this.setState({ numberOfNights, selectedToDate });
            } else {
                toastr.error("Checkout date exceeds itinerary end date", "");
                const maxNights = Math.floor((maxDate - selectedFromDate) / (1000 * 60 * 60 * 24)) || 1;
                const adjustedToDate = new Date(selectedFromDate);
                adjustedToDate.setDate(selectedFromDate.getDate() + maxNights);
                this.setState({ numberOfNights: maxNights, selectedToDate: adjustedToDate });
            }
        } else {
            this.setState({ numberOfNights });
        }
    }

    handleFromDateChange = (date) => {
        const { itinerary, numberOfNights } = this.state;
        if (!date || !itinerary.start_date || !itinerary.end_date) return;

        const minDate = new Date(itinerary.start_date);
        const maxDate = new Date(itinerary.end_date);
        if (date >= minDate && date <= maxDate) {
            const selectedToDate = new Date(date);
            selectedToDate.setDate(date.getDate() + numberOfNights);
            if (selectedToDate <= maxDate) {
                this.setState({ selectedFromDate: date, selectedToDate });
            } else {
                const adjustedNights = Math.floor((maxDate - date) / (1000 * 60 * 60 * 24)) || 1;
                const adjustedToDate = new Date(date);
                adjustedToDate.setDate(date.getDate() + adjustedNights);
                this.setState({
                    selectedFromDate: date,
                    selectedToDate: adjustedToDate,
                    numberOfNights: adjustedNights
                });
            }
        } else {
            toastr.error("Check-in date must be within itinerary dates", "");
        }
    }

    handleToDateChange = (date) => {
        const { selectedFromDate, itinerary } = this.state;
        if (!date || !selectedFromDate || !itinerary.end_date) return;

        const maxDate = new Date(itinerary.end_date);
        if (date >= selectedFromDate && date <= maxDate) {
            const numberOfNights = Math.ceil((date - selectedFromDate) / (1000 * 60 * 60 * 24)) || 1;
            this.setState({ selectedToDate: date, numberOfNights });
        } else {
            toastr.error("Invalid checkout date", "");
        }
    }

    handleEditHotelSubmit = async () => {
        const { selectedFromDate, selectedToDate, selectedHotelMealType, selected_hotel } = this.state;
    
        if (!selectedHotelMealType?.value) {
            toastr.error("Select Meal Type", "");
            return;
        }
    
        if (!selectedFromDate || !selectedToDate) {
            toastr.error("Invalid date selection", "");
            return;
        }

        this.setState({ editHotelloading: true });
    
        const data = {
            from_date: `${selectedFromDate.getFullYear()}-${selectedFromDate.getMonth() + 1}-${selectedFromDate.getDate()}`,
            to_date: `${selectedToDate.getFullYear()}-${selectedToDate.getMonth() + 1}-${selectedToDate.getDate()}`,
            price_type: selectedHotelMealType.value
        };
    
        const numberOfDays = Math.ceil((selectedToDate - selectedFromDate) / (1000 * 60 * 60 * 24));
        if (numberOfDays <= 0) {
            toastr.error("Invalid date selection", "");
            this.setState({ editHotelloading: false });
            return;
        }
    
        const room_price = selected_hotel?.room_price || [];
        let total_price = 0;
        const is_season = this.is_Season();
    
        for (let i = 0; i < room_price.length; i++) {
            if (!room_price[i].room) {
                console.warn("Room details missing for index", i);
                continue;
            }
    
            const count = parseInt(room_price[i].count, 10) || 1;
            const mealTypeKey = selectedHotelMealType.value;
            const priceField = is_season ? `on_season_${mealTypeKey}_price` : `${mealTypeKey}_price`;
    
            const raw_price = room_price[i].room[priceField];
            const price_per_person = parseFloat(raw_price || "0");
    
            const roomTypes = room_price.map(item => item?.room.room_type?.name);
            const hasOnlyExtraBed = roomTypes.every(name => name === "Extra Bed");
            
            const price_for_room = price_per_person * count * numberOfDays;
            total_price += price_for_room;

            if (hasOnlyExtraBed) {
                total_price = 0;
            }
        }
        data["margin_price"] = total_price;

        await this.handleUpdateHotelData(selected_hotel.id, data);
    }
    
    handleUpdateHotelData = async (id, data) => {
        const requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.props.access}` },
            body: JSON.stringify(data)
        };
        try {
            const response = await fetch(`${BaseUrl}/api/itineraries/itinerary-hotels/${id}/`, requestOptions);
            if (response.status >= 400) {
                const errorData = await response.json();
                console.error("Error updating hotel:", errorData);
                toastr.error("Something Went Wrong", "");
                this.setState({ editHotelloading: false });
            } else {
                const hotel_data = await response.json();
                toastr.success(`${hotel_data.hotel.name} Updated Successfully`, "");
                await this.loadselectedHotelData(id);
                this.setState({ editHotelloading: false });
            }
        } catch (error) {
            console.error("Error updating hotel:", error);
            toastr.error("Something Went Wrong", "");
            this.setState({ editHotelloading: false });
        }
    }

    getHotelPrice = (mealtype = null) => {
        const { hotelPricing, selectedRooms, selectedToDate, selectedFromDate } = this.state;
        
        let total_price = 0;
        let count = [];
    
        if (selectedRooms.length !== 0 && selectedToDate && selectedFromDate) {
            const rooms = selectedRooms;
    
            for (let i = 0; i < rooms.length; i++) {
                const Count = parseInt(document.getElementById(`${i}`)?.value) || 0;
                count.push(Count);
                
                const selected_price = hotelPricing.find(hotel => hotel.id === rooms[i]);
    
                if (!selected_price) {
                    console.warn(`Price not found for room ID: ${rooms[i]}`);
                    continue;
                }
    
                if (Count > 0) {
                    const is_season = this.is_Season();
                    const price_per_person = mealtype === "map" ? 
                        (is_season ? selected_price.on_season_map_price : selected_price.map_price) :
                        mealtype === "cp" ? 
                        (is_season ? selected_price.on_season_cp_price : selected_price.cp_price) :
                        (is_season ? selected_price.on_season_ep_price : selected_price.ep_price);
    
                    total_price += parseInt(price_per_person) * Count;
                }
            }
    
            const no_of_days = Math.max(1, getDifferenceInDays(selectedToDate, selectedFromDate));
            total_price *= no_of_days;
        }
    
        this.setState({ price: total_price });
        return { total: total_price, count };
    }

    handleSaveHotel = async (e, values) => {
        const { itinerary, selectedHotel, selectedFromDate, selectedToDate, selectedHotelMealType, selectedRooms } = this.state;
        if (selectedRooms.length === 0) {
            toastr.error("Please Select Room", "");
            return;
        }
        if (!selectedToDate || !selectedFromDate) {
            toastr.error("Please Select Check-In and Check-Out", "");
            return;
        }
        if (!selectedHotelMealType.value) {
            toastr.error("Select Meal Type", "");
            return;
        }

        this.setState({ addHotelloading: true });
        
        const price_data = this.getHotelPrice(selectedHotelMealType.value);
        const total_price = price_data.total;
        const count = price_data.count;

        const rooms_data = {
            itinerary: itinerary.id,
            room: selectedRooms,
            count
        };

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.props.access}` },
            body: JSON.stringify(rooms_data)
        };
        try {
            const response = await fetch(`${BaseUrl}/api/itineraries/itinerary-hotel-rooms/`, requestOptions);
            if (response.status >= 400) {
                const errorData = await response.json();
                console.error("Error saving hotel rooms:", errorData);
                toastr.error("Something Went Wrong", "");
                this.setState({ addHotelloading: false });
                return;
            }

            const data = await response.json();
            const newdata = {
                itinerary: itinerary.id,
                hotel: selectedHotel.value,
                rooms_count: values.rooms_count,
                price_type: selectedHotelMealType.value,
                room_price: data,
                margin_price: total_price,
                from_date: `${selectedFromDate.getFullYear()}-${selectedFromDate.getMonth() + 1}-${selectedFromDate.getDate()}`,
                to_date: `${selectedToDate.getFullYear()}-${selectedToDate.getMonth() + 1}-${selectedToDate.getDate()}`
            };

            const hotelRequestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.props.access}` },
                body: JSON.stringify(newdata)
            };
            const hotelResponse = await fetch(`${BaseUrl}/api/itineraries/itinerary-hotels/`, hotelRequestOptions);
            if (hotelResponse.status >= 400) {
                const errorData = await hotelResponse.json();
                console.error("Error saving hotel:", errorData);
                toastr.error("Something Went Wrong", "");
                this.setState({ addHotelloading: false });
                return;
            }

            const hotel_data = await hotelResponse.json();
            toastr.success(`${hotel_data.hotel.name} Added Successfully`, "");
            await this.loadItineraryHotels();
            this.setState({ addHotelloading: false });
        } catch (error) {
            console.error("Error saving hotel:", error);
            toastr.error("Something Went Wrong", "");
            this.setState({ addHotelloading: false });
        }
    }

    render() {
        const { itineraryHotels, selected_hotel, selectedHotelData, itinerary } = this.state;
        const Hotelcolumns = [
            {
                dataField: "id",
                text: "id",
                hidden: true,
            },
            {
                dataField: "hotel",
                text: "Hotel Name",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (
                    <Link to={`/hotel/${row.hotel.id}`} target="_blank" className="text-dark me-2">{row.hotel.name}</Link>
                )
            },
            {
                dataField: "place",
                text: "Location",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (
                    row.hotel.place ? `${row.hotel.place.name}` : "-"
                )
            },
            {
                dataField: "from_date",
                text: "Check-In",
                editable: false,
                sort: true,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (
                    Moment(row.from_date).format("DD-MM-YYYY")
                ),
                align: () => 'center'
            },
            {
                dataField: "to_date",
                text: "Check-Out",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (
                    Moment(row.to_date).format("DD-MM-YYYY")
                ),
                align: () => 'center'
            },
            {
                dataField: "room_price",
                text: "Category",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (
                    <p key={`hotel${row.id}`}>
                        {row.room_price.map((selectd_room, i) => (
                            <span key={`a_${i}`}>{selectd_room.room.room_type ? selectd_room.room.room_type.name : "-"} ✕{selectd_room.count}<br /></span>
                        ))}
                    </p>
                )
            },
            {
                dataField: "price_type",
                text: "Meal Plan",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (
                    toTitleCase(row.price_type)
                )
            },
            {
                dataField: "margin_price",
                text: "Total Price",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c', width: '10%' },
                formatter: (cellContent, row) => (
                    "₹ " + row.margin_price
                ),
                align: () => 'right'
            },
            {
                dataField: "menu",
                isDummyField: true,
                text: "Action",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c', width: '10%' },
                formatter: (cellContent, row) => (
                    <div style={{ textAlign: "center" }}>
                        <Link to="#" onClick={() => this.handleHotelEdit(row.id)} className="text-secondary me-2"><i className="mdi mdi-lead-pencil font-size-18"></i></Link>
                        <Link to="#" onClick={() => this.setState({ hotel_id: row.id, hotel_alert_confirm: true })} className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
                    </div>
                )
            },
        ];

        const HotelcolumnsnotEdit = [
            {
                dataField: "id",
                text: "id",
                hidden: true,
            },
            {
                dataField: "hotel",
                text: "Hotel Name",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (
                    <Link to={`/hotel/${row.hotel.id}`} target="_blank" className="text-dark me-2">{row.hotel.name}</Link>
                )
            },
            {
                dataField: "place",
                text: "Location",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (
                    row.hotel.place ? `${row.hotel.place.name}` : "-"
                )
            },
            {
                dataField: "from_date",
                text: "Check-In",
                editable: false,
                sort: true,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (
                    Moment(row.from_date).format("DD-MM-YYYY")
                ),
                align: () => 'center'
            },
            {
                dataField: "to_date",
                text: "Check-Out",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (
                    Moment(row.to_date).format("DD-MM-YYYY")
                ),
                align: () => 'center'
            },
            {
                dataField: "room_price",
                text: "Category",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (
                    row.room_price.map((selectd_room) => (
                        <p key={selectd_room.id}>{selectd_room.room.room_type ? selectd_room.room.room_type.name : "-"}✕{selectd_room.count}</p>
                    ))
                )
            },
            {
                dataField: "price_type",
                text: "Meal Plan",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (
                    toTitleCase(row.price_type)
                )
            },
            {
                dataField: "margin_price",
                text: "Total Price",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (
                    "₹ " + row.margin_price
                ),
                align: () => 'right'
            },
        ];

        const hotelEditColumn = [
            {
                dataField: "id",
                text: "id",
                hidden: true,
                sort: true,
            },
            {
                dataField: "room_price",
                text: "Category",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (
                    row.room.room_type.name
                )
            },
            {
                dataField: "count",
                text: "Count",
                headerStyle: { backgroundColor: '#fcb92c' },
            },
            {
                dataField: "menu",
                isDummyField: true,
                text: "Action",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c', width: '10%' },
                formatter: (cellContent, row) => (
                    <div style={{ textAlign: "center" }}>
                        <Link to="#" onClick={() => this.setState({ hotel_id: row, edithotel_alert_confirm: true })} className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
                    </div>
                )
            },
        ];

        return (
            <React.Fragment key={"hotel-Detail"}>
                <Row>
                    <Col xs={12}>
                        <Card>
                            {!["tour completed"].includes(itinerary.status) && this.props.user?.role !== 1 ?
                                <CardBody>
                                    <div className="table-responsive">
                                        <BootstrapTable
                                            keyField="id"
                                            data={itineraryHotels}
                                            columns={Hotelcolumns}
                                            defaultSorted={[{
                                                dataField: 'from_date',
                                                order: 'asc'
                                            }]}
                                            cellEdit={cellEditFactory({ mode: 'click', blurToSave: true })}
                                        />
                                    </div>
                                    <div style={{ textAlign: "center" }}>
                                        <Button color="secondary" outline className="waves-effect me-1 mb-3" onClick={this.tog_addHotel}>
                                            Assign New Hotel
                                        </Button>
                                    </div>
                                </CardBody>
                                :
                                <CardBody>
                                    <div className="table-responsive">
                                        <BootstrapTable
                                            keyField="id"
                                            data={itineraryHotels}
                                            columns={HotelcolumnsnotEdit}
                                            defaultSorted={[{
                                                dataField: 'from_date',
                                                order: 'asc'
                                            }]}
                                        />
                                    </div>
                                </CardBody>
                            }
                        </Card>
                    </Col>
                </Row>
                <Col sm={6} md={4} xl={3} className="mt-4">
                    <Modal
                        isOpen={this.state.model_addHotel}
                        toggle={this.tog_addHotel}
                        centered={true}
                        key={`assign_hotel`}
                    >
                        <ModalHeader toggle={() => this.clearStateData()}>
                            Add Hotel
                        </ModalHeader>
                        <ModalBody>
                            <AvForm className="needs-validation" onValidSubmit={this.handleSaveHotel}>
                                <Row>
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label">Location</Label>
                                            <Select
                                                value={this.state.selectedHotelLocation}
                                                onChange={this.handleSelectedHotelLocation}
                                                options={this.state.hotelLocationsGroup}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label">Hotel Type</Label>
                                            <Select
                                                value={this.state.selectedHotelRating}
                                                onChange={this.handleSelectedHotelRating}
                                                options={HotelRatingType}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label" htmlFor="start_date">Check-In</Label>
                                            <DatePicker
                                                className="form-control"
                                                minDate={itinerary.start_date ? new Date(itinerary.start_date) : null}
                                                maxDate={itinerary.end_date ? new Date(itinerary.end_date) : null}
                                                selected={this.state.selectedFromDate}
                                                onChange={this.handleFromDateChange}
                                                selectsStart
                                                startDate={itinerary.start_date ? new Date(itinerary.start_date) : null}
                                                placeholderText="Check-In"
                                                dateFormat="dd/MM/yyyy"
                                            />
                                        </div>
                                    </Col>
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label" htmlFor="end_date">Check-Out</Label>
                                            <DatePicker
                                                className="form-control"
                                                selected={this.state.selectedToDate}
                                                onChange={this.handleToDateChange}
                                                selectsEnd
                                                startDate={this.state.selectedFromDate}
                                                minDate={this.state.selectedFromDate}
                                                maxDate={itinerary.end_date ? new Date(itinerary.end_date) : null}
                                                placeholderText="Check-Out"
                                                dateFormat="dd/MM/yyyy"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label">Number of Nights</Label>
                                            <AvField
                                                name="number_of_nights"
                                                type="number"
                                                placeholder="Enter Number of Nights"
                                                value={this.state.numberOfNights}
                                                onChange={this.handleNumberOfNightsChange}
                                                validate={{
                                                    required: { value: true },
                                                    // min: { value: 1, errorMessage: "Must be at least 1 night" },
                                                    pattern: { value: "^[0-9]+$", errorMessage: "Only Digits" }
                                                }}
                                            />
                                        </div>
                                    </Col>
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label">Hotel</Label>
                                            <Select
                                                value={this.state.selectedHotel}
                                                onChange={this.handleSelectedHotel}
                                                options={this.state.hotelsGroup}
                                                classNamePrefix="select2-selection"
                                            />
                                            <p style={{ fontSize: '12px' }}>{selectedHotelData ? selectedHotelData.place.name : ""}</p>
                                        </div>
                                    </Col>
                                </Row>
                                {Array.from(Array(this.state.count)).map((c, index) => (
                                    <Row key={`room-${index}`}>
                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label className="form-label">Category</Label>
                                                <Select
                                                    onChange={(e) => this.handleSelectedRooms(e, index)}
                                                    options={this.state.HotelRoomTypeGroup}
                                                    classNamePrefix="select2-selection"
                                                    id={`category-${index}`}
                                                    value={this.state.HotelRoomTypeGroup[0]?.options.find(
                                                        option => option.value === this.state.selectedRooms[index]
                                                    ) || null}
                                                />
                                            </div>
                                        </Col>
                                        <Col md="6">
                                            <div className="mb-3">
                                                <AvField
                                                    id={index}
                                                    name="rooms_count"
                                                    label="No of Rooms"
                                                    type="number"
                                                    placeholder="Enter No of Rooms"
                                                    errorMessage="Enter Only Digits"
                                                    onChange={(e) => this.getHotelPrice(this.state.selectedHotelMealType.value)}
                                                    validate={{
                                                        required: { value: true },
                                                        pattern: {
                                                            value: "^[0-9]+$",
                                                            errorMessage: "Only Digits"
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                ))}
                                {this.state.count < (itinerary.pax || 1) ? <Button type="button" className="btn-sm" onClick={this.addInput} color="info"><i className="fas fa-plus"></i></Button> : ""}
                                {" "}
                                {this.state.count > 1 ? <Button className="btn-sm" type="button" onClick={this.removeInput} color="danger"><i className="fas fa-minus"></i></Button> : ""}
                                <Row>
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label">Meal Plan</Label>
                                            <Select
                                                onChange={(e) => { this.setState({ selectedHotelMealType: e }); this.getHotelPrice(e.value); }}
                                                value={this.state.selectedHotelMealType}
                                                options={HotelPricingType}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label">Hotel Price</Label>
                                            <h6 className="mt-2">₹ {this.state.price}</h6>
                                        </div>
                                    </Col>
                                </Row>
                                <FormGroup className="mb-0 mt-3">
                                    {this.state.addHotelloading ? (
                                        <Spinner className="me-2 mt-2" color="primary" />
                                    ) : (
                                        <div>
                                            <Button type="submit" color="primary" className="me-1">
                                                Submit
                                            </Button>
                                        </div>
                                    )}
                                </FormGroup>
                            </AvForm>
                        </ModalBody>
                    </Modal>
                </Col>
                <Col sm={6} md={4} xl={3} className="mt-4">
                    <Modal
                        isOpen={this.state.model_editHotel}
                        toggle={this.tog_editHotel}
                        centered={true}
                        backdrop="static"
                    >
                        <ModalHeader
                            toggle={() => {
                                // this.handleEditHotelSubmit();
                                setTimeout(() => {
                                    this.clearStateData();
                                    this.loadItineraryHotels();
                                }, 1000);
                            }}
                        >
                            Edit {selected_hotel.hotel ? selected_hotel.hotel.name : ""} Hotel Booking
                        </ModalHeader>
                        <ModalBody>
                            <Nav tabs className="nav-tabs-custom nav-justified">
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: this.state.activeTabJustify === "5"
                                        })}
                                        onClick={() => {
                                            this.toggleCustomJustified("5");
                                        }}
                                    >
                                        <span className="d-none d-sm-block">Hotel Detail</span>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: this.state.activeTabJustify === "6"
                                        })}
                                        onClick={() => {
                                            this.toggleCustomJustified("6");
                                        }}
                                    >
                                        <span className="d-none d-sm-block">Rooms</span>
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={this.state.activeTabJustify}>
                                <TabPane tabId="5" className="p-3">
                                    <AvForm className="needs-validation" onValidSubmit={() => this.handleEditHotelSubmit()}>
                                        <Row>
                                            <Col md="6">
                                                <div className="mb-3">
                                                    <Label className="form-label" htmlFor="start_date">Check-In</Label>
                                                    <DatePicker
                                                        className="form-control"
                                                        minDate={itinerary.start_date ? new Date(itinerary.start_date) : null}
                                                        maxDate={itinerary.end_date ? new Date(itinerary.end_date) : null}
                                                        selected={this.state.selectedFromDate}
                                                        onChange={this.handleFromDateChange}
                                                        selectsStart
                                                        startDate={itinerary.start_date ? new Date(itinerary.start_date) : null}
                                                        placeholderText="Check-In"
                                                        dateFormat="dd/MM/yyyy"
                                                    />
                                                </div>
                                            </Col>
                                            <Col md="6">
                                                <div className="mb-3">
                                                    <Label className="form-label" htmlFor="end_date">Check-Out</Label>
                                                    <DatePicker
                                                        className="form-control"
                                                        selected={this.state.selectedToDate}
                                                        onChange={this.handleToDateChange}
                                                        selectsEnd
                                                        startDate={this.state.selectedFromDate}
                                                        minDate={this.state.selectedFromDate}
                                                        maxDate={itinerary.end_date ? new Date(itinerary.end_date) : null}
                                                        placeholderText="Check-Out"
                                                        dateFormat="dd/MM/yyyy"
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="6">
                                                <div className="mb-3">
                                                    <Label className="form-label">Number of Nights</Label>
                                                    <AvField
                                                        name="number_of_nights"
                                                        type="number"
                                                        placeholder="Enter Number of Nights"
                                                        value={this.state.numberOfNights}
                                                        onChange={this.handleNumberOfNightsChange}
                                                        validate={{
                                                            required: { value: true },
                                                            min: { value: 1, errorMessage: "Must be at least 1 night" },
                                                            pattern: { value: "^[0-9]+$", errorMessage: "Only Digits" }
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md="6">
                                                <div className="mb-3">
                                                    <Label className="form-label">Meal Plan</Label>
                                                    <Select
                                                        onChange={(e) => this.setState({ selectedHotelMealType: e })}
                                                        value={this.state.selectedHotelMealType}
                                                        options={HotelPricingType}
                                                        classNamePrefix="select2-selection"
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                        <FormGroup className="mb-0 mt-2">
                                            {this.state.editHotelloading ? (
                                                <Spinner className="me-2 mt-2" color="primary" />
                                            ) : (
                                                <div>
                                                    <Button type="submit" color="primary" className="me-1">
                                                        Update
                                                    </Button>
                                                </div>
                                            )}
                                        </FormGroup>
                                    </AvForm>
                                </TabPane>
                                <TabPane tabId="6" className="p-3">
                                    <Row>
                                        <div className="table-responsive">
                                            <BootstrapTable
                                                keyField="id"
                                                data={selected_hotel.room_price || []}
                                                columns={hotelEditColumn}
                                                cellEdit={cellEditFactory({
                                                    mode: 'dbclick',
                                                    blurToSave: true,
                                                    afterSaveCell: (oldValue, newValue, row) => { this.handleRoomCountSave(oldValue, row); }
                                                })}
                                            />
                                        </div>
                                    </Row>
                                    <Button type="button" className="btn-sm" onClick={this.tog_addRooms} color="info"><i className="fas fa-plus"></i></Button>
                                </TabPane>
                            </TabContent>
                        </ModalBody>
                    </Modal>
                </Col>
                <Col sm={6} md={4} xl={3} className="mt-4">
                    <Modal
                        isOpen={this.state.model_addRooms}
                        toggle={this.tog_addRooms}
                        centered={true}
                    >
                        <ModalHeader toggle={() => { this.setState({ model_addRooms: false, selectedRoomType: { label: "Select Category", value: null } }); }}>
                            Add Category {selected_hotel.hotel ? "in " + selected_hotel.hotel.name : ""}
                        </ModalHeader>
                        <ModalBody>
                            <AvForm className="needs-validation" onValidSubmit={this.handleAddRoomSubmit}>
                                <Row>
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label">Category</Label>
                                            <Select
                                                value={this.state.selectedRoomType}
                                                onChange={this.handleSelectedRoomType}
                                                options={this.state.HotelRoomTypeGroup}
                                                classNamePrefix="select2-selection"
                                                id={'category'}
                                            />
                                        </div>
                                    </Col>
                                    <Col md="6">
                                        <div className="mb-3">
                                            <AvField
                                                name="rooms_count"
                                                label="No of Rooms"
                                                type="number"
                                                placeholder="Enter No of Rooms"
                                                errorMessage="Enter Only Digits"
                                                validate={{
                                                    required: { value: true },
                                                    pattern: {
                                                        value: "^[0-9]+$",
                                                        errorMessage: "Only Digits"
                                                    }
                                                }}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <FormGroup className="mb-0 mt-3">
                                    {this.state.addRoomsloading ? (
                                        <Spinner className="me-2 mt-2" color="primary" />
                                    ) : (
                                        <div>
                                            <Button type="submit" color="primary" className="me-1">
                                                Submit
                                            </Button>
                                        </div>
                                    )}
                                </FormGroup>
                            </AvForm>
                        </ModalBody>
                    </Modal>
                </Col>
                {this.state.hotel_alert_confirm ? (
                    <SweetAlert
                        title="Are you sure?"
                        warning
                        showCancel
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="danger"
                        onConfirm={() => this.handleHotelDelete(this.state.hotel_id)}
                        onCancel={() => this.setState({ hotel_alert_confirm: false, hotel_id: "" })}
                    >
                        You won't be able to revert this!
                    </SweetAlert>
                ) : null}
                {this.state.hotel_success_confirm ? (
                    <SweetAlert
                        success
                        title={this.state.dynamic_title}
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="danger"
                        onConfirm={() => this.setState({ hotel_success_confirm: false, hotel_alert_confirm: false })}
                    >
                        {this.state.dynamic_description}
                    </SweetAlert>
                ) : null}
                {this.state.edithotel_alert_confirm ? (
                    <SweetAlert
                        title="Are you sure?"
                        warning
                        showCancel
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="danger"
                        onConfirm={() => this.handleHotelRoomDelete(this.state.hotel_id)}
                        onCancel={() => this.setState({ edithotel_alert_confirm: false, hotel_id: "" })}
                    >
                        You won't be able to revert this!
                    </SweetAlert>
                ) : null}
                {this.state.edithotel_success_confirm ? (
                    <SweetAlert
                        success
                        title={this.state.dynamic_title}
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="danger"
                        onConfirm={() => this.setState({ edithotel_success_confirm: false, edithotel_alert_confirm: false })}
                    >
                        {this.state.dynamic_description}
                    </SweetAlert>
                ) : null}
            </React.Fragment>
        );
    }
}

export default HotelsDetail;